<template>
  <div>
    <image-with-loading
      :src="'https://m2.ikea.cn/' + config.image.url"
      :width="config.image.width"
      :height="config.image.height"
    />
    <!-- <h1>{{config.title}}</h1> -->
    <div class="text" v-html="config.lead"></div>
  </div>
</template>

<script>
import ImageWithLoading from "@/components/ImageWithLoading";

export default {
  props: ["config"],
  components: {
    ImageWithLoading
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {

  }
};
</script>

<style scoped>
img {
  margin: 0px 0px;
}
h1 {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  padding: 0px 40px;
}
.text {
  padding: 0px 20px;
  color: #111;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/HeroComponent.vue